import { useNavbarInfo } from "~/stores/useNabvarInfo";

export default defineNuxtRouteMiddleware((to, from) => {
  const store = useNavbarInfo();
  store.navbar.title = "";
  store.navbar.tabs = [];

  return true;
});
